export { PLUGIN_KEY, PLUGIN_PRIORITY, HiddenRows } from "./hiddenRows.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/hiddenRows/index.mjs
// module id = 1444
// module chunks = 1